import { filterContentCards } from '../../../../shared/utilities/braze';
import { HERO_INTRO_PROMO_TEMPLATE } from '../../../../shared/constants/contentCards';

export function translateContentCardMediaUrl(
  url,
  brazeContentCardLink,
  brazeContentCardLinkReplaceWith
) {
  if (url && brazeContentCardLink && brazeContentCardLinkReplaceWith) {
    return url.replace(brazeContentCardLink, brazeContentCardLinkReplaceWith);
  }
  return url;
}

function withTranslatedMediaExtras(extras, brazeContentCardLink, brazeContentCardLinkReplaceWith) {
  if (!extras) {
    return extras;
  }

  const translate = (key) =>
    translateContentCardMediaUrl(
      extras[key],
      brazeContentCardLink,
      brazeContentCardLinkReplaceWith
    );

  return {
    ...extras,
    desktopVideoUrl: translate('desktopVideoUrl'),
    mobileVideoUrl: translate('mobileVideoUrl'),
    desktopImageUrl: translate('desktopImageUrl'),
    mobileImageUrl: translate('mobileImageUrl'),
  };
}

export function selectGiftingHeroContentCard(
  contentCards,
  selectedStore,
  currentUrl,
  brazeContentCardLink,
  brazeContentCardLinkReplaceWith
) {
  const storeId =
    selectedStore?.id !== undefined ? parseInt(selectedStore.id, 10) : null;

  const filtered = filterContentCards(
    contentCards,
    [HERO_INTRO_PROMO_TEMPLATE],
    storeId,
    currentUrl
  );

  const card = filtered[0];
  if (!card) {
    return null;
  }

  const extras = card.extras || card.e || {};
  return {
    ...card,
    extras: withTranslatedMediaExtras(
      extras,
      brazeContentCardLink,
      brazeContentCardLinkReplaceWith
    ),
  };
}

export function getCardExtras(card) {
  return card?.extras || card?.e || {};
}

/** Picks desktop/mobile image URLs; video KVPs are unused on the gifting hero. */
export function getResponsiveHeroImageUrl(extras, isNarrowViewport) {
  const desktopImageUrl = extras?.desktopImageUrl;
  const mobileImageUrl = extras?.mobileImageUrl;

  return isNarrowViewport
    ? mobileImageUrl || desktopImageUrl
    : desktopImageUrl;
}
